<template>
    <v-img src="https://static.offch.com/storage/logo/rightel-logo-min.png" max-width="50px"></v-img>
</template>

<script>
export default {
    name: "mtn"
}
</script>

<style type="text/css">

</style>